import { PORTAL_TRACKER_KEY_MAP } from './modules/index'
import {userInfo} from '@/global'
import HUAMNDASH_BOARD from './modules/humanDashboard/index.js'
import containerMgmtTrackers from './modules/containerMgmt/index.js'
// import { UserModule } from '@/store/modules/user'

// 公共参数
const hostname = window.location.hostname
let TRACKER_KEY = 'iWMS'
// 老版 公共参数设置为 fop
// if (hostname === 'ifop.jd.com') {
//   TRACKER_KEY = 'fop'
// }
// // 新版 公共参数设置为 workbench
// if (hostname === 'workbench-ifop.jd.com') {
//   TRACKER_KEY = 'workbench'
// }

// 公共埋点方法
// const tracker = (keyName, params) => {
//   const commonTrackParams = {
//     currentTime: new Date().getTime(),
//     pin: userInfo.userCode,
//     warehouseNo:userInfo.warehouseNo,
//     timeout: window.responseNetTime,
//   }
//   try {
//     // 未传keyName 或 无此埋点 则中断埋点
//     if (!keyName || !HUAMNDASH_BOARD[keyName]) return
//     const { key = '', label = '' } = HUAMNDASH_BOARD[keyName]
//     console.log('tracker', TRACKER_KEY, key, { label, ...commonTrackParams, ...params })
//     window.log(TRACKER_KEY, key, JSON.stringify({ label, ...commonTrackParams, ...params }))
//   } catch (error) {
//     console.log('TRACKER_ERROR', error)
//   }
// }
export const tracker = (keyName, params) => {
  console.log("🚀 ~ tracker ~ keyName:", keyName)
  if (!keyName) return;

  const commonTrackParams = {
    pin: userInfo.userCode,
    warehouseNo: userInfo.warehouseNo,
    userName: userInfo.userName
  };

  const currentTrackerObj = HUAMNDASH_BOARD[keyName] || containerMgmtTrackers[keyName];
  console.log("🚀 ~ tracker ~ currentTrackerObj:", currentTrackerObj)
  if (!currentTrackerObj) return;

  const { key = '', label = '' } = currentTrackerObj;
  const trackParams = { label, ...commonTrackParams, ...params };

  try {
    window.log && window.log(TRACKER_KEY, key, JSON.stringify(trackParams));
  } catch (error) {
    console.error('TRACKER_ERROR', error);
  }
};


export const printTracker=(key,params)=>{
  const {userCode,warehouseName,warehouseNo,userName}=userInfo
  const commonTrackParams = {
    pin:userCode,
    pgUserNo: userCode,
    userName:userName,
    warehouseNo:warehouseNo,
    warehouseName:warehouseName,
    warehouseType:'iWMS',
    clsType:1,
    aType:'print',
  }
  try {
    // 未传keyName 或 无此埋点 则中断埋点
    // if (!key) return
    // console.log('tracker', TRACKER_KEY, key, { key, ...commonTrackParams, ...params })
    window.log && window.log(key,'',JSON.stringify({ ...commonTrackParams, ...params }))
  } catch (error) {
    console.log('TRACKER_ERROR', error)
  }

}


